import React from "react";
import "./Privacy.scss";

const Privacy = () => {
  return (
    <div className="container-fluid login" id="about" style={{ height: "unset" }}>
      <form>
        <h1 style={{marginTop:"20px"}}>TERMS AND CONDITIONS</h1>
<p style={{marginTop:"10px",}}>PLEASE DOWNLOAD THE PDF FILE BELOW TO READ OUR TEAMS AND CONDITION</p>
        <a
          href="/MLMTC.pdf" // Path to your PDF file in public folder
          download="MLMTC.pdf"
          className="btn"
          style={{backgroundColor:"blue",color:"white"}}
        >
          Download PDF
        </a>
      </form>
    </div>
  );
};

export default Privacy;
